var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-container',[_c('v-row',{staticClass:"text-center mb-12"},[_c('v-col',{staticClass:"text-h4"},[_vm._v(_vm._s(_vm.$t(_vm.info.heading)))])],1),_c('v-row',{staticClass:"text-center justify-center"},[_c('v-col',{staticClass:"text-h6 font-weight-light"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.info.text))}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }